import React from "react";
import { BiWorld } from "react-icons/bi";
import { GiTreasureMap } from "react-icons/gi";
import { SuggestionItem } from "../../SuggestionItem";

import { SuggestionListProps } from "../types";
import {
  Column,
  ColumnTitle,
  ContainerDivisor,
  FixedContainer,
  FixedList,
  ScrollableContainer,
  ScrollableList,
  SectionTitle,
  SuggestionListWrapper,
} from "./styles";

export const SuggestionList: React.FC<SuggestionListProps> = ({
  title,
  type,
  nationalTitle,
  internationalTitle,
  nationals,
  internationals,
  isSearchTermTyped,
  onSelect,
}) => (
  <SuggestionListWrapper>
    {/* Contêiner fixo */}
    {(!isSearchTermTyped || type === "destination") && (
      <>
        {/* Título principal */}
        {title && !isSearchTermTyped && <SectionTitle>{title}</SectionTitle>}
        <FixedContainer>
          <Column>
            {nationalTitle && (
              <ColumnTitle>
                <GiTreasureMap /> {nationalTitle}
              </ColumnTitle>
            )}
            {!isSearchTermTyped && (
              <FixedList>
                {(nationals ?? [])
                  .filter((suggestion) => suggestion.destak)
                  .map((suggestion) => (
                    <SuggestionItem
                      key={suggestion.code}
                      city={suggestion.name}
                      code={suggestion.code}
                      destak={suggestion.destak}
                      onClick={() => onSelect(suggestion)}
                    />
                  ))}
              </FixedList>
            )}
          </Column>
          {type === "destination" && (
            <Column>
              {internationalTitle && (
                <>
                  <ColumnTitle>
                    <BiWorld /> {internationalTitle}
                  </ColumnTitle>
                  {!isSearchTermTyped && (
                    <FixedList>
                      {internationals
                        ?.filter((suggestion) => suggestion.destak)
                        .map((suggestion) => (
                          <SuggestionItem
                            key={suggestion.code}
                            city={suggestion.name}
                            code={suggestion.code}
                            destak={suggestion.destak}
                            onClick={() => onSelect(suggestion)}
                          />
                        ))}
                    </FixedList>
                  )}
                </>
              )}
            </Column>
          )}
        </FixedContainer>
        <ContainerDivisor />
      </>
    )}

    {/* Contêiner rolável */}
    <ScrollableContainer>
      <Column>
        <ScrollableList>
          {(nationals ?? [])
            .filter((suggestion) => isSearchTermTyped || !suggestion.destak)
            .map((suggestion) => (
              <SuggestionItem
                key={suggestion.code}
                city={suggestion.name}
                code={suggestion.code}
                // destak={suggestion.destak}
                onClick={() => onSelect(suggestion)}
              />
            ))}
        </ScrollableList>
      </Column>
      {type === "destination" && (
        <Column>
          <ScrollableList>
            {internationals
              ?.filter((suggestion) => !suggestion.destak)
              ?.map((suggestion) => (
                <SuggestionItem
                  key={suggestion.code}
                  city={suggestion.name}
                  code={suggestion.code}
                  destak={suggestion.destak}
                  onClick={() => onSelect(suggestion)}
                />
              ))}
          </ScrollableList>
        </Column>
      )}
    </ScrollableContainer>
  </SuggestionListWrapper>
);
